export async function runExclusiveAnamnesisSave(lockRef, save) {
  if (lockRef.current) return false;
  lockRef.current = true;
  try {
    await save();
    return true;
  } finally {
    lockRef.current = false;
  }
}
